module.exports = __webpack_public_path__ + "static/media/ic-mobile-error@3x.452f02cb.png";